import React, { useState, useEffect } from "react";
import moment from "moment";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Modal from "../Modal/Modal";
import { FormControl, FormLabel, FormControlLabel, RadioGroup, Radio } from "@material-ui/core";
const axios = require("axios");
import TimePicker from "rc-time-picker";
import { makeStyles } from "@material-ui/core/styles";

import "./SendingFormDataModal.scss";
import "rc-time-picker/assets/index.css";
import "../../styles/sendFormDataForm.scss";
import "../Contact/Contact.scss";

import {
  getAnimalSpeciesLabel,
  getGeneralConditionLabel,
  getBodyTempLabel,
  getGlandColorLabel,
  getBreathFreqLabel,
  getDrinkingBehaviorLabel,
  getDrinkingSinceLabel,
  getEatingBehaviorLabel,
  getEatingSinceLabel,
  getUrineBehaviorLabel,
  getUrineSinceLabel,
  getDroppingsBehaviorLabel,
  getDroppingsSinceLabel,
  getVomitingBehaviorLabel,
  getVomitingSinceLabel,
} from "./components/LabelHelpers";

import BlockContent from "../block-content";

const customCancelButtonStyles = (theme) => ({
  root: {
    backgroundColor: "#efefef",
    color: "#000",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#d4d4d4",
      boxShadow: "none",
    },
  },
});

const customSubmitButtonStyles = (theme) => ({
  root: {
    backgroundColor: "var(--color-main)",
    color: "#fff",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#000",
      boxShadow: "none",
    },
  },
});

const CustomSubmitButton = withStyles(customSubmitButtonStyles)(Button);
const CustomCancelButton = withStyles(customCancelButtonStyles)(Button);

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: "100%",
  },
  formControlDatePicker: {
    margin: "0.5rem 0 0 0.5rem",
    minWidth: "100%",
  },
}));

const SendingFormDataModal = React.memo(
  ({
    modalToggled,
    toggleModal,
    submitButtonText,
    cancelButtonText,
    formData,
    handleSendingDataSuccess,
    handleSendingDataError,
    sendingFormData,
    clinics,
    location,
  }) => {
    const contactInfoInitState = {
      firstName: "",
      lastName: "",
      email: "",
      tel: "",
      customerInClinic: false,
      houseClinic: "",
      timeOfArrival: moment().format("HH:mm"),
    };
    const classes = useStyles();

    const [formStep, setFormStep] = useState(0);
    const [contactInfo, setContactInfo] = useState(contactInfoInitState);
    const [validationErrors, setValidationErrors] = useState({
      email: {
        valid: true,
        label: "",
      },
    });

    const [errorState, setErrorState] = useState("");

    const resolveClinicId = new Promise((resolve, reject) => {
      let urlParams = new URLSearchParams(location.search);
      const _id = urlParams.get("utm_referrer");

      let referralDot = _id?.indexOf(".");
      let clinicId = _id?.slice(referralDot + 1);

      resolve(clinicId);
      reject(() => {
        console.log("rejected");
      });
    });

    useEffect(() => {
      resolveClinicId
        .then((clinicId) => {
          let filteredClinic = clinics.filter((clinic) => {
            return clinic._id === clinicId;
          });

          setContactInfo({ ...contactInfo, houseClinic: filteredClinic[0].name });
        })
        .catch((e) => {
          // fail silently! it's ok don't worry
        });
    }, []);

    const handleContactInfoChange = (event) => {
      const target = event.target;
      const value = target.value;
      const name = target.name;

      setContactInfo({ ...contactInfo, [name]: value });
    };

    const handleCustomerInClinicChange = (event) => {
      const target = event.target;
      const value = target.value;

      setContactInfo({ ...contactInfo, customerInClinic: value });
    };

    const onTimeChange = (value) => {
      setContactInfo({ ...contactInfo, timeOfArrival: value.format("HH:mm") });
    };

    const validateEmail = () => {
      setValidationErrors({
        ...validationErrors,
        email: { ...validationErrors.email, label: "", valid: true },
      });

      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );

      if (!pattern.test(contactInfo.email)) {
        setValidationErrors({
          ...validationErrors,
          email: {
            ...validationErrors.email,
            label: "Bitte gib eine gültige E-Mail Adresse ein.",
            valid: false,
          },
        });
      }
    };

    const handleCancel = () => {
      toggleModal();
    };

    const handleSubmit = (e) => {
      let { firstName, lastName, email, tel, customerInClinic, timeOfArrival } = contactInfo;

      let data = {
        firstName,
        lastName,
        email,
        tel,
        customerInClinic,
        timeOfArrival,
        selectedClinic: {
          email: formData.selectedClinic.email,
        },
        animalinfo: {
          animalname: formData.animalinfo.animalname,
          age: formData.animalinfo.age,
          species: getAnimalSpeciesLabel(formData.animalinfo.species),
          sex: formData.animalinfo.sex === "female" ? "Weiblich" : "Männlich",
          weight: formData.animalinfo.weight,
          castrated: formData.animalinfo.castrated ? "Ja" : "Nein",
          preconditions: {
            heart: formData.animalinfo.preconditions.heart ? "Ja" : "Nein",
            kidney: formData.animalinfo.preconditions.kidney ? "Ja" : "Nein",
            liver: formData.animalinfo.preconditions.liver ? "Ja" : "Nein",
            epilepsia: formData.animalinfo.preconditions.epilepsia ? "Ja" : "Nein",
            cancer: formData.animalinfo.preconditions.cancer ? "Ja" : "Nein",
            other: "",
          },
          lastHeat:
            formData.animalinfo.sex === "female"
              ? moment(formData.animalinfo.lastHeat).format("DD-MM-YYYY")
              : null,
          pregnant: formData.animalinfo.pregnant ? "Ja" : "Nein",
          givingBirth: formData.animalinfo.givingBirth ? "Ja" : "Nein",
          free: formData.animalinfo.free ? "Ja" : "Nein",
          abroadLocation: "",
          wormcure: new Date(),
          vaccine: new Date(),
          rawFood: "",
        },
        generalcondition: getGeneralConditionLabel(formData.generalcondition),
        vitalvalues: {
          bodyTemp: getBodyTempLabel(formData.vitalvalues.bodyTemp),
          glandColor: getGlandColorLabel(formData.vitalvalues.glandColor),
          breathFreq: getBreathFreqLabel(formData.vitalvalues.breathFreq),
        },
        drinkandeat: {
          drinking: {
            behavior: getDrinkingBehaviorLabel(formData.drinkandeat.drinking.behavior),
            since: getDrinkingSinceLabel(formData.drinkandeat.drinking.since),
          },
          eating: {
            behavior: getEatingBehaviorLabel(formData.drinkandeat.eating.behavior),
            since: getEatingSinceLabel(formData.drinkandeat.eating.since),
          },
        },
        excretions: {
          urine: {
            behavior: getUrineBehaviorLabel(formData.excretions.urine.behavior),
            since: getUrineSinceLabel(formData.excretions.urine.since),
            bloody: formData.excretions.urine.bloody ? "Ja" : "Nein",
          },
          droppings: {
            behavior: getDroppingsBehaviorLabel(formData.excretions.droppings.behavior),
            since: getDroppingsSinceLabel(formData.excretions.droppings.since),
            bloody: formData.excretions.droppings.bloody ? "Ja" : "Nein",
            black: formData.excretions.droppings.black ? "Ja" : "Nein",
          },
          vomiting: {
            behavior: getVomitingBehaviorLabel(formData.excretions.vomiting.behavior),
            since: getVomitingSinceLabel(formData.excretions.vomiting.since),
            foamy: formData.excretions.vomiting.foamy ? "Ja" : "Nein",
            bile: formData.excretions.vomiting.bile ? "Ja" : "Nein",
            bloody: formData.excretions.vomiting.bloody ? "Ja" : "Nein",
          },
        },
        specialcases: {
          birth: false,
          cramp: false,
          accident: false,
          foreignObject: false,
          homeAnimals: false,
          intoxications: false,
        },
      };

      axios
        .post("/.netlify/functions/submitDataToClinic", JSON.stringify(data))
        .then((response) => {
          if (response.status !== 200) {
            handleSendingDataError();
          } else {
            handleSendingDataSuccess();
          }
        });
      e.preventDefault();
    };

    const cancelButton = (buttonText, action) => (
      <CustomCancelButton
        className="sendingFormDataModal__Buttons--cancel"
        size="small"
        variant="contained"
        onClick={action}
        type="submit"
      >
        {buttonText}
      </CustomCancelButton>
    );

    const submitButton = (buttonText, action) => (
      <CustomSubmitButton
        className="sendingFormDataModal__Buttons--continue"
        size="small"
        variant="contained"
        color="primary"
        type="submit"
        onClick={action}
      >
        {buttonText}
      </CustomSubmitButton>
    );

    return (
      <div className="sendingFormDataModal">
        <Modal modalToggled={modalToggled} toggleModal={toggleModal} hasClosingButton={false}>
          <div>
            <h1>{formStep === 0 ? sendingFormData.titleStep1 : sendingFormData.titleStep2}</h1>

            <form name="Kontaktdaten" className="sendFormData--form" onSubmit={handleSubmit}>
              <div className="sendingFormDataModal--content">
                {formStep === 0 && (
                  <>
                    <BlockContent blocks={sendingFormData._rawInfoText || []} />
                  </>
                )}
              </div>

              {formStep === 0 ? (
                <div className="sendFormDataForm--grid">
                  <p className="form-field sendFormData--firstName">
                    <label htmlFor="name" className="control-label">
                      <span className="label">Vorname</span>
                      <input
                        type="text"
                        name="firstName"
                        required="required"
                        onChange={handleContactInfoChange}
                      />
                    </label>
                  </p>

                  <p className="form-field sendFormData--lastName">
                    <label htmlFor="name" className="control-label">
                      <span className="label">Nachname</span>
                      <input
                        type="text"
                        name="lastName"
                        required="required"
                        onChange={handleContactInfoChange}
                      />
                    </label>
                  </p>

                  <p className="form-field sendFormData--tel">
                    <label htmlFor="tel" className="control-label">
                      <span className="label">Handy Nr.</span>
                      <input
                        type="tel"
                        name="tel"
                        required="required"
                        onChange={handleContactInfoChange}
                      />
                    </label>
                  </p>

                  <p className="form-field sendFormData--email">
                    <label htmlFor="email" className="control-label">
                      <span className="label">E-Mail</span>
                      <input
                        type="email"
                        name="email"
                        required="required"
                        onChange={handleContactInfoChange}
                        onBlur={validateEmail}
                      />
                    </label>
                    <span className="sendFormData__validation--error">
                      {validationErrors.email.label}
                    </span>
                  </p>

                  <FormControl
                    component="fieldset"
                    className={`${classes.formControl} sendFormData--customerInClinic`}
                  >
                    <FormLabel component="legend">
                      Bereits Kunde in der ausgewählten Praxis/Klinik
                    </FormLabel>
                    <RadioGroup
                      row={true}
                      aria-label="customerInClinic"
                      name="customerInClinic"
                      value={contactInfo.customerInClinic}
                      onChange={handleCustomerInClinicChange}
                    >
                      <FormControlLabel value={"true"} control={<Radio />} label="Ja" />
                      <FormControlLabel value={"false"} control={<Radio />} label="Nein" />
                    </RadioGroup>
                  </FormControl>

                  <p className="form-field sendFormData--houseClinic">
                    <label htmlFor="houseClinic" className="control-label">
                      <span className="label">Dein Haustierarzt</span>
                      <input
                        type="text"
                        name="houseClinic"
                        value={contactInfo.houseClinic}
                        onChange={handleContactInfoChange}
                      />
                    </label>
                  </p>

                  <FormControl
                    className={`${classes.formControlDatePicker} sendFormData--timeOfArrival`}
                  >
                    <FormLabel component="legend">Geschätzte Ankunftszeit:</FormLabel>
                    <TimePicker
                      style={{ width: 100 }}
                      showSecond={false}
                      defaultValue={moment()}
                      className="sendFormData--TimePicker"
                      onChange={onTimeChange}
                      clearIcon={false}
                      allowEmpty={false}
                    />
                  </FormControl>
                </div>
              ) : null}

              {formStep === 1 && (
                <div className="sendingFormDataModal__results">
                  <h4>Tierdaten</h4>

                  <div className="sendingFormDataModal__results__flexRow">
                    <div>
                      <span>Tiername: </span>
                      {formData.animalinfo.animalname}
                    </div>
                    <div>
                      <span>Tierart: </span>

                      {getAnimalSpeciesLabel(formData.animalinfo.species)}
                    </div>
                    <div>
                      <span>Geschlecht: </span>
                      {formData.animalinfo.sex === "female" ? "Weiblich" : "Männlich"}
                    </div>
                    <div>
                      <span>Alter: </span>
                      {formData.animalinfo.age}
                    </div>
                    <div>
                      <span>Gewicht: </span>
                      {formData.animalinfo.weight} Kg
                    </div>
                  </div>
                  <div className="sendingFormDataModal__results__flexRow">
                    {formData.animalinfo.castrated && (
                      <div>
                        <span>Kastriert: </span>
                        Ja
                      </div>
                    )}
                    {formData.animalinfo.sex === "female" && (
                      <div>
                        <span>Letzte Läufigkeit: </span>
                        {moment(formData.animalinfo.lastHeat).format("DD-MM-YYYY")}
                      </div>
                    )}
                    {formData.animalinfo.pregnant && (
                      <div>
                        <span>Trächtig: </span>
                        Ja
                      </div>
                    )}
                    {formData.animalinfo.givingBirth && (
                      <div>
                        <span>In der Geburt: </span>
                        Ja
                      </div>
                    )}
                    {formData.animalinfo.free && (
                      <div>
                        <span>Freigänger: </span>
                        Ja
                      </div>
                    )}
                  </div>
                  {!!formData.animalinfo.preconditions.heart &&
                    !!formData.animalinfo.preconditions.kidney &&
                    !!formData.animalinfo.preconditions.liver &&
                    !!formData.animalinfo.preconditions.epilepsia &&
                    !!formData.animalinfo.preconditions.cancer && (
                      <>
                        <h5>Bekannte schwere Vorerkrankung</h5>
                        <div className="sendingFormDataModal__results__flexRow">
                          <div>
                            <span>Herz: </span>
                            {formData.animalinfo.preconditions.heart ? "Ja" : "Nein"}
                          </div>

                          <div>
                            <span>Niere: </span>
                            {formData.animalinfo.preconditions.kidney ? "Ja" : "Nein"}
                          </div>

                          <div>
                            <span>Leber: </span>
                            {formData.animalinfo.preconditions.liver ? "Ja" : "Nein"}
                          </div>

                          <div>
                            <span>Epilepsie: </span>
                            {formData.animalinfo.preconditions.epilepsia ? "Ja" : "Nein"}
                          </div>

                          <div>
                            <span>Krebserkrankung: </span>
                            {formData.animalinfo.preconditions.cancer ? "Ja" : "Nein"}
                          </div>

                          {formData.animalinfo.preconditions.other.length > 0 && (
                            <div>
                              <span>Freitext: </span>
                              {formData.animalinfo.preconditions.other}
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  {!formData.specialcases.birth &&
                    !formData.specialcases.cramp &&
                    !formData.specialcases.accident &&
                    !formData.specialcases.foreignObject &&
                    !formData.specialcases.homeAnimals &&
                    !formData.specialcases.intoxications && (
                      <>
                        {formData.generalcondition !== "none" && (
                          <>
                            <h5>Allgemeinzustand</h5>
                            <div className="sendingFormDataModal__results__flexRow">
                              <div>{getGeneralConditionLabel(formData.generalcondition)}</div>
                            </div>
                          </>
                        )}

                        <div className="sendingFormDataModal__results__flexRow">
                          <div>
                            <h5>Vitalwerte</h5>
                            <div className="sendingFormDataModal__results__flexRow">
                              <div>
                                <span>Körpertemperatur: </span>
                                {getBodyTempLabel(formData.vitalvalues.bodyTemp)}
                              </div>
                            </div>
                            <div className="sendingFormDataModal__results__flexRow">
                              <div>
                                <span>Farbe Schleimhäute: </span>
                                {getGlandColorLabel(formData.vitalvalues.glandColor)}
                              </div>
                            </div>
                            <div className="sendingFormDataModal__results__flexRow">
                              <div>
                                <span>Atemfrequenz: </span>
                                {getBreathFreqLabel(formData.vitalvalues.breathFreq)}
                              </div>
                            </div>
                          </div>
                          {formData.drinkandeat.drinking.behavior > 1 && (
                            <div>
                              <h5>Trink & Fressverhalten</h5>
                              <div className="sendingFormDataModal__results__flexRow">
                                <div>
                                  <span>Trinken: </span>
                                  {getDrinkingBehaviorLabel(formData.drinkandeat.drinking.behavior)}
                                </div>

                                <div>
                                  <span>Seit: </span>
                                  {getDrinkingSinceLabel(formData.drinkandeat.drinking.since)}
                                </div>
                              </div>
                              <div className="sendingFormDataModal__results__flexRow">
                                <div>
                                  <span>Fressen: </span>
                                  {getEatingBehaviorLabel(formData.drinkandeat.eating.behavior)}
                                </div>

                                <div>
                                  <span>Seit: </span>
                                  {getEatingSinceLabel(formData.drinkandeat.eating.since)}
                                </div>
                              </div>
                            </div>
                          )}
                          <div>
                            <h5>Ausscheidungen</h5>
                            <div className="sendingFormDataModal__results__flexRow">
                              {formData.excretions.urine.behavior > 1 && (
                                <>
                                  <div>
                                    <span>Urinabsatz: </span>
                                    {getUrineBehaviorLabel(formData.excretions.urine.behavior)}
                                  </div>
                                  <div>
                                    <span>Seit: </span>
                                    {getUrineSinceLabel(formData.excretions.urine.since)}
                                  </div>
                                  <div>
                                    <span>Blutig: </span>
                                    {formData.excretions.urine.bloody ? "Ja" : "Nein"}
                                  </div>
                                </>
                              )}
                            </div>
                            <div className="sendingFormDataModal__results__flexRow">
                              {formData.excretions.droppings.behavior > 1 && (
                                <>
                                  <div>
                                    <span>Kotabsatz: </span>
                                    {getDroppingsBehaviorLabel(
                                      formData.excretions.droppings.behavior
                                    )}
                                  </div>
                                  <div>
                                    <div>
                                      <span>Seit: </span>
                                      {getDroppingsSinceLabel(formData.excretions.droppings.since)}
                                    </div>

                                    <div>
                                      <span>Blutig: </span>
                                      {formData.excretions.droppings.bloody ? "Ja" : "Nein"}
                                    </div>

                                    <div>
                                      <span>Pechschwarz: </span>
                                      {formData.excretions.droppings.black ? "Ja" : "Nein"}
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>

                            <div className="sendingFormDataModal__results__flexRow">
                              <div>
                                <span>Erbrechen: </span>
                                {getVomitingBehaviorLabel(formData.excretions.vomiting.behavior)}
                              </div>
                              {formData.excretions.vomiting.behavior > 1 && (
                                <>
                                  <div>
                                    <span>Seit: </span>
                                    {getVomitingSinceLabel(formData.excretions.vomiting.since)}
                                  </div>
                                  {formData.excretions.vomiting.foamy && (
                                    <div>
                                      <span>Schaumig: Ja</span>
                                    </div>
                                  )}
                                  {formData.excretions.vomiting.bile && (
                                    <div>
                                      <span>Galle: Ja</span>
                                    </div>
                                  )}
                                  {formData.excretions.vomiting.bloody && (
                                    <div>
                                      <span>Blutig: Ja</span>
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                  <h4>Deine Daten</h4>
                  <div className="sendingFormDataModal__results__flexRow">
                    <div>
                      <p>
                        <span>Vorname: </span>
                        {contactInfo.firstName}
                      </p>
                    </div>
                    <div>
                      <p>
                        <span>Nachname: </span>
                        {contactInfo.lastName}
                      </p>
                    </div>
                  </div>

                  <div className="sendingFormDataModal__results__flexRow">
                    <div>
                      <p>
                        <span>Tel: </span>
                        {contactInfo.tel}
                      </p>
                    </div>
                    <div>
                      <p>
                        <span>E-Mail: </span>
                        {contactInfo.email}
                      </p>
                    </div>
                  </div>

                  <div>
                    <span>Ankunft: </span>
                    {contactInfo.timeOfArrival} Uhr
                  </div>

                  <div>
                    <span>{errorState}</span>
                  </div>
                </div>
              )}
              <div className="sendingFormDataModal__Buttons">
                {formStep === 0 && cancelButton(cancelButtonText, () => handleCancel())}
                {formStep === 1 && cancelButton("Zurück", () => setFormStep(formStep - 1))}

                {formStep === 0 &&
                  submitButton("Weiter", () => {
                    if (contactInfo.lastName && contactInfo.email) {
                      setFormStep(formStep + 1);
                      setErrorState("");
                    } else {
                      setErrorState(
                        "Bitte geben Sie mindestens Ihren Nachnamen und Ihre E-Mail-Adresse an!"
                      );
                    }
                  })}
                {formStep === 1 && submitButton(submitButtonText, () => console.log("submitted"))}
              </div>
            </form>
          </div>
        </Modal>
      </div>
    );
  }
);

export default SendingFormDataModal;
